const pageTitle = {
  'Youtube Live Shopping': '串接 YouTube Shopping',
};

export default pageTitle;
